import { creatorbase } from '@round/api';
import { StringSearchParams, useUrlState } from '@round/utils';

export type UrlState = {
    team?: number;
    project?: number;
    search?: string;
    billingEntity?: number;
};

const parseUrlParams = (urlState: StringSearchParams<UrlState>): UrlState => {
    return {
        team: urlState.team ? Number(urlState.team) : undefined,
        project: urlState.project ? Number(urlState.project) : undefined,
        search: urlState.search || undefined,
        billingEntity: urlState.billingEntity ? Number(urlState.billingEntity) : undefined,
    };
};

export const mapToApiParams = (urlState: UrlState): creatorbase.GetPurchaseOrdersParams => {
    return {
        team_id: urlState.team,
        project_id: urlState.project,
        search: urlState.search,
        billing_entity_id: urlState.billingEntity,
    };
};

export default function usePurchaseOrdersListUrlState() {
    const { url, mergeSearchParams } = useUrlState<UrlState>();

    return {
        urlState: parseUrlParams(url.searchParams),
        setUrlState: mergeSearchParams,
    };
}
